import { render, staticRenderFns } from "./phone-tags.vue?vue&type=template&id=0427ef11&scoped=true&"
import script from "./phone-tags.vue?vue&type=script&lang=js&"
export * from "./phone-tags.vue?vue&type=script&lang=js&"
import style0 from "./phone-tags.vue?vue&type=style&index=0&id=0427ef11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0427ef11",
  null
  
)

export default component.exports